import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loadingCard is-loading h-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "image group block h-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-50 overflow-hidden" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "grid grid-cols-4 items-center mn-h-6 mt-2" }
const _hoisted_5 = { class: "flex justify-center col-span-2 col-start-2 items-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "pl-8 pr-8 2xl:pl-12 2xl:pr-12 text-sm 2xl:text-lg font-extrabold text-oaiGray-300"
}
const _hoisted_8 = ["value", "disabled", "max"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = ["href"]

import { ArrowDownTrayIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/solid";
import { format, getDay, subDays } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Milestone } from "shared/composables/dailyTimelapsePlayer/milestones";
import { ProcessBox } from "shared/composables/dailyTimelapsePlayer/processBoxes";
import { DailyTimelapseResponse } from "shared/types/Camera";
import OaiVideoPlayer from "./OaiVideoPlayer.vue";
import TimelapseVideoPlayer from "./TimelapseVideoPlayer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyTimelapseContent',
  props: {
    enableHeaderDateField: { type: Boolean },
    date: {},
    timelapse: {},
    loading: { type: Boolean },
    milestones: { default: () => [] },
    processBoxes: { default: () => [] },
    contentClass: {},
    noSrcMessage: {}
  },
  emits: ["dateChange", "downloadClick"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useI18n();

const maxDate = computed(() => {
  const today = new Date();
  const monday = 1;
  if (getDay(today) === monday) {
    return subDays(today, 2);
  } else {
    return subDays(today, 1);
  }
});

const formatDate = (dateString: Date) => format(new Date(dateString), "dd.MM.yyyy");

const handleHeaderDatePickerChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("dateChange", target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.contentClass)
        }, [
          (_ctx.timelapse?.timestamps?.length)
            ? (_openBlock(), _createBlock(TimelapseVideoPlayer, {
                key: 0,
                autoPlay: "",
                loading: _ctx.loading,
                src: _ctx.timelapse?.url,
                noSrcMessage: _ctx.noSrcMessage || _unref(t)('err.no_timelapse_found'),
                milestones: _ctx.milestones,
                processBoxes: _ctx.processBoxes,
                timestamps: _ctx.timelapse.timestamps
              }, null, 8, ["loading", "src", "noSrcMessage", "milestones", "processBoxes", "timestamps"]))
            : (_openBlock(), _createBlock(OaiVideoPlayer, {
                key: 1,
                loading: _ctx.loading,
                src: _ctx.timelapse?.url,
                noSrcMessage: _ctx.noSrcMessage || _unref(t)('err.no_timelapse_found')
              }, null, 8, ["loading", "src", "noSrcMessage"])),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('dateChange', _ctx.timelapse?.previous ?? null))),
                type: "button",
                disabled: !(_ctx.timelapse && _ctx.timelapse.previous),
                class: "border-transparent inline-flex items-center px-4 text-sm font-medium"
              }, [
                _createVNode(_unref(ChevronLeftIcon), {
                  class: _normalizeClass(["h-6 w-6 text-oaiGray-300", { 'text-transparent': !(_ctx.timelapse && _ctx.timelapse.previous) }]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ], 8, _hoisted_6),
              (_ctx.date && !_ctx.enableHeaderDateField)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(formatDate(_ctx.date)), 1))
                : _createCommentVNode("", true),
              (_ctx.enableHeaderDateField)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    type: "date",
                    value: _ctx.date ? _unref(format)(_ctx.date, 'yyyy-MM-dd') : '',
                    onChange: handleHeaderDatePickerChange,
                    disabled: _ctx.loading,
                    max: _unref(format)(maxDate.value, 'yyyy-MM-dd'),
                    onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    class: "w-full h-[20px] rounded-md border-gray-300 text-xs shadow-sm focus:border-yellow-500 focus:ring-yellow-500",
                    style: {"width":"min-content !important"}
                  }, null, 40, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('dateChange', _ctx.timelapse?.next ?? null))),
                disabled: !(_ctx.timelapse && _ctx.timelapse.next),
                type: "button",
                class: "border-transparent inline-flex items-center px-4 text-sm font-medium"
              }, [
                _createVNode(_unref(ChevronRightIcon), {
                  class: _normalizeClass(["h-6 w-6 text-oaiGray-300", { 'text-transparent': !(_ctx.timelapse && _ctx.timelapse.next) }]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ], 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.timelapse)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('downloadClick')))
                  }, [
                    _createElementVNode("a", {
                      href: _ctx.timelapse.url
                    }, [
                      _createVNode(_unref(ArrowDownTrayIcon), { class: "h-6 w-6 hover:text-yellow" })
                    ], 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})